import { PAYMENT_AUTHORIZATION } from ".."
import { apiInstance } from "../config/apiInstance"

export const patchPaymentAuthorization = async(id:string, data:any) => {
    return apiInstance.patch( `${PAYMENT_AUTHORIZATION}/${id}/gloss-invoice`, data)
}